import { render, staticRenderFns } from "./WaitingAreas.vue?vue&type=template&id=3126f26d&"
import script from "./WaitingAreas.vue?vue&type=script&lang=js&"
export * from "./WaitingAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports